import axios from '@/axios.js'

export default {
  fetchDataListItems ({ commit },idoperation) {
    return new Promise((resolve, reject) => {
      axios.get('/paymentschedule/data/'+idoperation)
        .then((response) => {
          commit('SET_PAYMENTSCHEDULES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/paymentschedule/updateschedule', {item})
        .then((response) => {
          commit('UPDATE_PAYMENTSCHEDULES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/paymentschedule/insertschedule', {item})
        .then((response) => {
          commit('CREATE_PAYMENTSCHEDULES', Object.assign(response.data.data, {id: response.data.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
